module.exports = __webpack_public_path__ + "img/front_page_report.89cdc0c6.svg";